import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

export interface Office {
  officeNumber: number;
  officeName: string;
}

/** Real offices (office_number + office_name, from athena_bfsi_rbp.office). */
export function useOffices() {
  return useQuery({
    queryKey: ["reference", "offices"] as const,
    queryFn: () => apiGet<Office[]>("/offices"),
    staleTime: 5 * 60_000,
  });
}

/**
 * Real SIC divisions (`sic_division`) -- the actual "Industry" dimension.
 * When `office` (office_number) is given, scoped to only the industries that
 * office actually has calibration data for; otherwise the full portfolio-wide
 * list.
 */
export function useIndustries(office?: number) {
  return useQuery({
    queryKey: ["reference", "industries", office ?? "all"] as const,
    queryFn: () => apiGet<string[]>("/industries", { office: office != null ? String(office) : undefined }),
    staleTime: 5 * 60_000,
  });
}

/** Real `bankdwn_risk_rating_final` values (from annualized_loss_calibiration)
 *  -- fetched live rather than hardcoded, same reasoning as useIndustries: a
 *  fixed list silently drifts from what the table actually has (confirmed
 *  live it includes "Other" alongside A/B1/B2/B3). */
export function useRatings() {
  return useQuery({
    queryKey: ["reference", "ratings"] as const,
    queryFn: () => apiGet<string[]>("/ratings"),
    staleTime: 5 * 60_000,
  });
}
